import React from 'react';
import { ServiceDetailPage } from './ServiceDetailPage';






export const ControlDeCalidad: React.FC = () => {
  const serviceData = {
    title: 'Control de Calidad.',
    description: 'Realizamos ensayes de verificación y control de calidad a materiales utilizados en la construcción, conforme a normas nacionales e internacionales (NMX, ASTM, SICT y otras aplicables), garantizando resultados confiables para la toma de decisiones técnicas.',
    image: '/services/Ser_Int_Concreto.jpg',
    sections: [
      {
        title: 'Concreto',
        
        subsections: [
          {
            title: '',
            subtitle: 'Aseguramos que el concreto cumpla con los niveles de resistencia, consistencia y durabilidad requeridos para cada obra.',
            items: [
              'Revenimiento (asentamiento)',
              'Masa unitaria',
              'Contenido de aire',
              'Elaboración de especímenes',
              'Control de temperatura',
              'Resistencia a la compresión',
              'Extracción de núcleos',
              'Módulo elástico',
              'Resistencia a la flexión',
              'Tensión por compresión diametral'

            ]
          },
        ]
      },
            {
        title: 'Acero de Refuerzo',
        
        subsections: [
          {
            title: '',
            subtitle: 'Evaluamos las propiedades mecánicas y químicas del acero utilizado en elementos de concreto reforzado.',
            items: [
               'Ensayo de tensión',
               'Ensayo de doblado',
               'Ensayo de elongación',
               'Evaluación de malla electrosoldada',
               'Análisis de composición química',
               'Evaluación de torón de presfuerzo',
               'Evaluación de conectores (uniones)'

            ]
           },
           {
              title:'Acero Estructural',
              subtitle:'Verificación del comportamiento mecánico del acero empleado en estructuras metálicas.',
              items:[
                'Ensayo de tensión',
               'Ensayo de doblado',
               'Ensayo de elongación',
               'Análisis de composición química'
              ]
           }
        ]
      },
      
      {
        title: 'Terracerías',
        
        items:[
          'Estudios de Calidad de Materiales'
        ],
        // Esta sección solo tiene subsecciones (sin items directos)
        subsections: [
          {
            title: 'Materiales para Terracerías',
            subtitle: 'Evaluamos el comportamiento y desempeño de los materiales empleados en terracerías y rellenos.',
            items: [
               'Rellenos',
               'Subyacente y subrasante',
               'Sub-bases y bases',
               'Tezontle',
               'Balasto'

            ]
          },

          {
            title: 'Propiedades Mecánicas',
            items: [
              'Compresión simple',
              'Compresión triaxial (UU, CU, CD)',
              'Corte directo',
              'Consolidación unidimensional',
              'Permeabilidad en carga constante y variable'
            ]
          },
          {
            title: 'Ensayes Especiales',
            items: [
              'Compactación Proctor (estándar y modificado)',
              'Valor relativo de soporte (CBR)',
              'Expansión libre y bajo carga',
              'Colapso por saturación'
            ]
          }
        ]
      },

      
      {
        title:'Asfaltos',
        subsections:[
          {
            title:'',
            subtitle:'Evaluamos el desempeño de los materiales asfálticos para garantizar pavimentos durables y funcionales.',
            items:[
              'Ensayes a emulsiones',
              'Cemento asfáltico',
              'Diseño de mezclas',
              'Control de calidad',
              'Verificación de espesores y grados de compactación',
            ],
          },
        ],
      },

      {
        title:'Pruebas No Destructivas',
        subsections:[
          {
            title:'',
            subtitle:'En LIEC realizamos inspección especializada mediante pruebas no destructivas, permitiendo evaluar la calidad, integridad y continuidad de elementos estructurales sin afectar su funcionamiento ni resistencia.',
            items:[],
          },
          {
            title:'Inspección Superficial',
            subtitle:'Evaluación de discontinuidades visibles y superficiales en soldaduras y materiales.',
            items:[
              'Inspección visual',
              'Líquidos penetrantes',
              'Radiografía',
            ],
          },
          {
            title:'Inspección Volumétrica',
            subtitle:'Detección de discontinuidades internas que no son visibles a simple vista.',
            items:[
              'Ultrasonido industrial',
              'Radiografía',
            ]
          },
          {
            title:'Ensayos No Destructivos en Concreto',
            subtitle:'Evaluación del estado interno del concreto y la localización de elementos de refuerzo.',
            items:[
              'Velocidad de pulso',
              'Detección de acero',
            ],
          },
          {
            title:'Pruebas en Cimentaciones Profundas',
            subtitle:'Verificación de la integridad estructural de elementos profundos de cimentación.',
            items:[
              'PIT (Pile Integrity Test)',
              'Cross Hole',

            ]
          },

        ]
      },



      {
        title: 'Pruebas Especiales',
        subsections:[
          {
            title:'Ensayes Especializados',
            subtitle:'Realizamos ensayes especializados para garantizar la calidad, durabilidad y desempeño de los materiales, mediante la evaluación de sus propiedades físicas, mecánicas y químicas. Nuestros servicios están orientados a respaldar decisiones técnicas en proyectos de infraestructura, edificación e industria, bajo procedimientos y métodos acreditados.',
            items:[]
          },
          {
            title:'Suelos y Agregados',
            subtitle:'Evaluación de materiales para identificar su comportamiento frente a agentes agresivos y su compatibilidad con el concreto.',
            items:[
              'Contenido de materia orgánica mediante calcinación, colorimetría y titulación con permanganato de potasio',
              'Determinación de parámetros agresivos en suelo',
              'Reacción álcali-agregado por método químico y método de barras',

            ]
          },
          {
            title:'Losas y Losetas',
            subtitle:'Verificación de propiedades físicas y mecánicas para su desempeño en servicio.',
            items:[
              'Densidad',
              'Absorción',
              'Resistencia al impacto',
              'Resistencia al desgaste por abrasión',
              'Resistencia a la flexión',

            ]
          },
          {
            title:'Concreto Polimérico',
            subtitle:'Evaluación de materiales poliméricos utilizados en aplicaciones especiales.',
            items:[
              'Densidad y absorción',
              'Flamabilidad',
              'Resistencia al impacto',
              'Resistencia a rayos UV',
              'Ataque químico',
            ]
          },
          {
            title:'Durabilidad',
            subtitle:'Ensayes para evaluar la vida útil y el comportamiento del concreto frente a condiciones ambientales agresivas.',
            items:[
              'Profundidad de carbonatación',
              'Penetrabilidad al ion cloruro',
              'Resistividad eléctrica del concreto',
              'Densidad, absorción y vacíos en concreto endurecido',
              'Resistencia a los sulfatos en concreto',
              'Análisis petrográfico',
            ]
          },
          {
            title:'Agua',
            subtitle:'Control de calidad del agua utilizada en la elaboración de concreto.',
            items:[
              'Análisis fisicoquímico del agua',
            ]
          },
          {
            title:'Geotextil',
            subtitle:'Verificación de propiedades mecánicas para aplicaciones geotécnicas.',
            items:[
              'Elongación y tensión de geotextil',
            ]
          },
          
          {
            title:'Madera',
            subtitle:'Evaluación de propiedades físicas y mecánicas de elementos de madera estructural.',
            items:[
              'Densidad',
              'Módulo elástico',
              'Resistencia a la flexión',
              'Contenido de humedad',
              'Resistencia a la compresión',
              'Resistencia a esfuerzo cortante',
            ]
          },

          {
            title:'Otros Ensayes',
            subtitle:'Pruebas especializadas para materiales y aplicaciones específicas.',
            items:[
              'Contracción de vigas de concreto endurecido',
              'Contenido de cenizas en resinas con fibra de vidrio',
              'Densidad de material cementicio antifuego',
            ]
          },
        ],
        
      },
    ],
  };
  return <ServiceDetailPage {...serviceData} />;
};
